import { useContext } from 'react'

import { deprecationContext } from './deprecationContext'

/**
 * Hook for getting the current showDeprecated status
 */
export const useShowDeprecated = () => {
	const context = useContext(deprecationContext)

	if (!context) throw new Error('Cannot useDeprecation without a deprecation context')

	return context.showDeprecated
}
